var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "block-container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title required" }, [_vm._v("请选择工程师")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content" },
          [
            _vm._l(_vm.servcWorkVoucherStaffList, function(engineer) {
              return _c("div", [
                _c(
                  "p",
                  [
                    _c("span", [_vm._v(_vm._s(engineer.engineerName))]),
                    _vm._v(" "),
                    _c(
                      "el-radio",
                      {
                        attrs: { label: engineer.engineerId },
                        model: {
                          value: _vm.checkValue,
                          callback: function($$v) {
                            _vm.checkValue = $$v
                          },
                          expression: "checkValue"
                        }
                      },
                      [_vm._v("是否主工程师  ")]
                    )
                  ],
                  1
                )
              ])
            }),
            _vm._v(" "),
            _c("label", { staticClass: "mr20" }, [
              _c(
                "a",
                {
                  staticClass: "swb-btn-link",
                  on: { click: _vm.engineerSelect }
                },
                [_vm._v("+ 选择工程师")]
              )
            ])
          ],
          2
        )
      ]),
      _vm._v(" "),
      _vm.optFlag == "change"
        ? _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title required" }, [
              _vm._v("请选择转单原因")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content" },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "fl",
                    attrs: { placeholder: "请选择", clearable: true },
                    model: {
                      value: _vm.transDesc,
                      callback: function($$v) {
                        _vm.transDesc = $$v
                      },
                      expression: "transDesc"
                    }
                  },
                  _vm._l(_vm.transCauseList, function(transCause) {
                    return _c("el-option", {
                      key: transCause.id,
                      attrs: { label: transCause.name, value: transCause.name }
                    })
                  })
                )
              ],
              1
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption bg-white dashed" }, [
      _c("span", [_vm._v("选择工程师")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08994af0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08994af0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/workVoucher/ToChangeEngineers.vue
// module id = 1945
// module chunks = 1